import {
    isAreaGraphWidgetComplete,
    isComboChartWidgetComplete,
    isDonutChartWidgetComplete,
    isGaugeWidgetComplete,
    isHorizontalBarGraphWidgetComplete,
    isImageWidgetComplete,
    isLineGraphWidgetComplete,
    isMultiBarGraphWidgetComplete,
    isNumberTileWidgetComplete,
    isPieChartWidgetComplete,
    isProgressBarWidgetComplete,
    isStackedBarGraphWidgetComplete,
    isTableWidgetComplete,
    isTextWidgetComplete,
} from "~/components/reports/widgetSpecific/widgetCompletion";
import type {Widget} from "~/components/reports/widgetSpecific/widgets";
import {WidgetType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/reportsWorkspaceCapability/domain/ReportJson";
import type {EnumDictionary} from "~/typeDefinitions";
import type {StoredWidget} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/reportsWorkspaceCapability/domain/ReportJson";

export const widgetTypeToIsWidgetComplete: EnumDictionary<StoredWidget["type"], (widget: Widget) => boolean> = {
    [WidgetType.multiBarGraph]: isMultiBarGraphWidgetComplete,
    [WidgetType.stackedBarGraph]: isStackedBarGraphWidgetComplete,
    [WidgetType.horizontalBarGraph]: isHorizontalBarGraphWidgetComplete,
    [WidgetType.lineGraph]: isLineGraphWidgetComplete,
    [WidgetType.numberTile]: isNumberTileWidgetComplete,
    [WidgetType.pieChart]: isPieChartWidgetComplete,
    [WidgetType.donutChart]: isDonutChartWidgetComplete,
    [WidgetType.text]: isTextWidgetComplete,
    [WidgetType.image]: isImageWidgetComplete,
    [WidgetType.table]: isTableWidgetComplete,
    [WidgetType.progressBar]: isProgressBarWidgetComplete,
    [WidgetType.gauge]: isGaugeWidgetComplete,
    [WidgetType.areaGraph]: isAreaGraphWidgetComplete,
    [WidgetType.comboChart]: isComboChartWidgetComplete,
};
